import { useParams } from "react-router-dom";

import { EmojiButtonInterface } from "@pages/VideoSessions/types";
import { useAdminData } from "@providers/AdminDataProvider";

interface EmojiButtonProps {
  button: EmojiButtonInterface;
  onEmojiClick: (emoji: EmojiButtonInterface) => void;
  disabled?: boolean;
  count: number | null;
}

export const EmojiButton: React.FC<EmojiButtonProps> = ({ button, onEmojiClick, disabled = false, count }) => {
  const { mediaId } = useParams();
  const { isUserRBT } = useAdminData();

  return (
    <button
      key={button.value}
      onClick={(e?: React.MouseEvent<HTMLElement>) => {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (isUserRBT && !mediaId) return;
        onEmojiClick(button);
      }}
      disabled={disabled}
      className={`
          flex flex-row items-center
          sm:px-3 py-2 sm:my-0 gap-2 max-[640px]:px-2 max-[640px]:gap-1 px-6 my-2
          rounded-full
          transition-colors duration-200
          focus:outline-hidden
          ${
            disabled
              ? "bg-gray-50 border border-gray-200 cursor-not-allowed"
              : `
              bg-white border border-[#D9D4CF]
              hover:bg-[#EDEAE7] hover:border-[#C1B9B0]
              active:bg-[#C1B9B0]
              focus:ring-2 focus:ring-offset-2 focus:ring-[#D9D4CF]
            `
          }
        `}
    >
      <span
        className={`
            flex items-center justify-center w-4 h-4
            ${disabled ? "opacity-25" : ""}
          `}
      >
        {button.emoji}
      </span>
      <span
        className={`
            text-sm font-semibold leading-[22px] max-[640px]:text-[12px] sm:inline hidden
            ${disabled ? "text-[#C1B9B0]" : "text-[#4E4440]"}
          `}
      >
        {button.text}
      </span>
      {isUserRBT && !mediaId ? (
        <span className={` max-[640px]:text-[12px] ${disabled ? "text-[#C1B9B0]" : "text-[#4E4440]"}`}>
          {count || 0}
        </span>
      ) : null}
    </button>
  );
};
